import {
  captureNotificationIdentity,
  type CapturedNotificationIdentity,
  type NotificationCaptureRef,
} from './notificationCompletion.ts';
import { recitalCompTrackerCopy } from './trackerCopy.ts';

interface PresentableNotification extends NotificationCaptureRef {
  title: string;
  body: string;
}

/**
 * Freeze identity from the raw Firestore record before applying display-only
 * legacy copy migrations. Dismiss must compare against the raw record, not
 * the words rendered on screen.
 */
export function presentNotification<T extends PresentableNotification>(
  id: string,
  value: T
): T & { id: string; sourceIdentity: CapturedNotificationIdentity } {
  return {
    id,
    ...value,
    sourceIdentity: captureNotificationIdentity(id, value),
    title: recitalCompTrackerCopy(value.title),
    body: recitalCompTrackerCopy(value.body),
  };
}
